export const config = {
  tokenDataUrl:
    "https://raw.githubusercontent.com/relend-network/RelendAssets/refs/heads/feature/reorga/instances/current.json",
};
